import { config } from '@config'
import { storage } from '@services/storageService'
import axios from 'axios'

export class CancelProductService {
  getProductOrderDetails = async (bsgId: string, bspId: string) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}order/buyingSessionGroup/${bsgId}/buyingSessionProduct/${bspId}/cancelProductOrderDetails`
      const accessToken: string = storage.getItem('access_token')
      const response: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response?.data
    } catch (e) {
      console.log(e)
    }
  }

  markCancelReplaceProduct = async (
    bsgId: string,
    bspId: string,
    clientOrderIds: Array<string>,
    doorOrderIds: Array<string>,
    sendNotification: boolean
  ) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}order/buyingSessionGroup/${bsgId}/buyingSessionProduct/${bspId}/removeReplaceProduct`
      const accessToken: string = storage.getItem('access_token')
      const body = {
        replaceBuyingSessionProductId: null,
        clientOrderIds,
        doorOrderIds,
        sendNotification
      }
      const response: any = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response?.data
    } catch (e) {
      console.log(e)
    }
  }
}
